"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDateFormatter = void 0;
var date_fns_1 = require("date-fns");
var locale_1 = require("date-fns/locale");
var useCurrentLang_1 = require("./useCurrentLang");
var dateFnsLocales = {
    ru: locale_1.ru,
    en: locale_1.enGB,
    es: locale_1.es
};
var dateFns = {
    format: date_fns_1.format,
    formatDistance: date_fns_1.formatDistance,
    formatDuration: date_fns_1.formatDuration
};
var bind = function (fn, locale) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = Array(fn.length)
            .fill(true)
            .map(function (_, i) { return (i !== fn.length - 1 ? args[i] : __assign(__assign({}, args[i]), { locale: locale })); });
        return fn.apply(void 0, params);
    });
};
var useDateFormatter = function () {
    var lang = useCurrentLang_1.useCurrentLang();
    return Object.keys(dateFns).reduce(function (result, name) {
        var _a;
        return (__assign(__assign({}, result), (_a = {}, _a[name] = bind(dateFns[name], dateFnsLocales[lang] || locale_1.enGB), _a)));
    }, {});
};
exports.useDateFormatter = useDateFormatter;
